import { Pedido, PedidoItem } from "@fixeduy/restaurantestypes";
import EscPosEncoder from "esc-pos-encoder";
import { useMonedasStore } from "../services/monedas";
import { useMonedasDiccionarioStore } from "../stores/monedas";

declare const qz: any;

function formatLine(left: string, right: string, width = 32) {
  const space = width - left.length - right.length;
  if (space < 0) {
    return left.slice(0, width - right.length) + right;
  }
  return left + " ".repeat(space) + right;
}

export async function imprimirComandaCompleta({
  pedido,
  lineas,
  ip,
  port,
  agruparItems = false
}: {
  pedido: Pedido;
  lineas: PedidoItem[];
  ip: string;
  port: number;
  titulo?: string;
  agruparItems?: boolean;
}) {
  const monedasStore = useMonedasStore();
  const monedasDiccinarioStore = useMonedasDiccionarioStore();

  const moneda = monedasStore.getMonedaById(pedido.moneda);
  const simboloMoneda = monedasDiccinarioStore.monedas.find(
    m => m.codigoIso === moneda?.codigoIso
  )?.simbolo;

  const encoder = new EscPosEncoder();

  encoder.initialize();
  encoder.codepage("cp858");

  encoder.align("left").width(1).height(1).bold(false).line("");

  encoder
    .align("center")
    .width(2)
    .height(2)
    .bold(true)
    .line("Detalle de pedido")
    .bold(false)
    .width(1)
    .height(1);

  encoder.newline();
  encoder.newline();

  for (const linea of lineas) {
    encoder
      .width(1)
      .height(1)
      .line(formatLine(linea.nombre, `${simboloMoneda}${linea.total}`));

    encoder.line(
      formatLine(
        `${linea.cantidad} x ${simboloMoneda}${linea.precioUnitarioConIva}`,
        ""
      )
    );
  }

  separador(encoder);

  encoder.align("right");

  encoder.line(`Subtotal: ${simboloMoneda}${pedido.subtotal}`);
  encoder.line(`IVA: ${simboloMoneda}${pedido.montoIva}`);
  encoder.line(`Total: ${simboloMoneda}${pedido.total}`);

  separador(encoder);

  encoder.align("center").bold(true).line("DOCUMENTO INFORMATIVO");
  encoder.align("center").bold(false).line("NO VÁLIDO COMO COMPROBANTE FISCAL");

  separador(encoder);
  encoder.newline().newline().newline().newline();
  encoder.cut();

  // -------------------------------------------------
  // QZ Tray: conectar, enviar ticket, desconectar
  // -------------------------------------------------
  try {
    if (!qz.websocket.isActive()) {
      await qz.websocket.connect();
    }

    const bytes = encoder.encode();
    const hexData = Array.from(bytes)
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");

    const config = qz.configs.create({
      type: "raw",
      host: ip, // IP de la impresora
      port: port,
      encoding: "UTF-8"
    });
    const data = [{ type: "raw", format: "hex", data: hexData }];

    await qz.print(config, data);
  } catch (err) {
    console.error("Error al imprimir:", err);
  } finally {
    if (qz.websocket.isActive()) {
      await qz.websocket.disconnect();
    }
  }
}

// ---------------- funciones auxiliares ----------------
function separador(encoder: EscPosEncoder) {
  encoder.newline();
  encoder.align("center");
  encoder.line("---------------------------------------");
  encoder.newline();
}
